import Vue from 'vue';
import Axios from 'axios'
import Modal from '@/components/Modal/index'
Vue.prototype.$Modal = Modal;
//引入多语言基础插件
import ServerPlugin from '@/../../plugins/server.js';
import { isGrayEnvironment, changeEnvironment } from '@/../../plugins/util.js';
//引入语言包的库
import serverLib from '@/lib/server.js';

import { getUrlParameter } from '@/utils/assist'
// 环境变量
let noChangeGrayEnvironment = true, isEnvironment = isGrayEnvironment();
setTimeout(() => {
  noChangeGrayEnvironment = false;
}, 30000);
// Vue.prototype.axios = axios.create({
//   timeout: 3000
// });
ServerPlugin.set({
	Axios,
	serverLib,
	loading(status){
		// do it
		// if(status){
		// 	$nuxt.$loading.start()
		// }else{
		// 	setTimeout(() => $nuxt.$loading.finish(), 500);
		// }
	},
	//key:"b15ae13796ea20b4" //如果是标准版,则需要设置该项
});
let data = ServerPlugin.mixin.data(),
    requestList = {},
    urlObj = getUrlParameter();
//统一的响应拦截 isIntercept存在，则忽略错误
ServerPlugin.axios.interceptors.response.use((res) => {
  let reqArg = res.config.data,
    resArg = res.data,
    msg = resArg.msg;
  if (resArg.status === 1001) {
    // 切换环境
    if (noChangeGrayEnvironment) {
      changeEnvironment();
    } else {
      Modal.error({
        title: '提示',
        content: '当前运营商版本有更新，点击确认切换到新版',
        onOk() {
          changeEnvironment();
        }
      });
    }
    return Promise.reject(msg);
  }
  if (res.status!== 200 || (resArg.status !== 1&&reqArg&&reqArg.indexOf('isIntercept') === -1)) {
    Modal.error({
      title: '提示',
      content: msg || '服务器错误'
    });
    return Promise.reject(msg)
  }
  return res.data
}, (error) => {
  // return Promise.reject(error)
  // 对响应错误做点什么
});
data.server.require = function ({url='',data={},isCheck=false,type = "post"}) {
  // 添加CC专属操作
  let actionName = 'default', CancelToken = Axios.CancelToken, cancelList = requestList[actionName]  || [], time = new Date().getTime();
  if (isEnvironment) {
    url = '/new' + url;
  }
  if (data) {
    data = JSON.parse(data);
    actionName = data.actionName;
    data.operatorType = urlObj.operatorType || 0 ;
    data.operatorName = urlObj.operatorName;
    localStorage.setItem('operatorType', data.operatorType)
    localStorage.setItem('operatorName', data.operatorName)
    data.clientIsGray = isEnvironment ? 1 : 0;
    data = JSON.stringify(data);
  }
  requestList[actionName] = cancelList; // 新增请求取消token
  return ServerPlugin.axios.request({
    url,
    method: type,
    data,
    cancelToken: new CancelToken(function executor(c) {
      cancelList.push({fn:c, time});
    })
  }).finally(() => {
    // 清除对应取消请求函数
    cancelList.forEach((value, index) => {
      if (value.time === time)cancelList.splice(index, 1);
    });
  })
};
data.server.requestList = requestList;
//全局混入
Vue.mixin({
  data () {
    return data
  }
});




// WEBPACK FOOTER //
// ./plugins/server.js